var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "navigation__outer-wrapper" }, [
    _vm.ismobile
      ? _c(
          "div",
          { staticClass: "navigation__wrapper--mobile" },
          [
            _c(
              "div",
              {
                staticClass: "primary-navigation__item--mobile",
                on: {
                  click: function($event) {
                    _vm.showCarCats = !_vm.showCarCats
                  }
                }
              },
              [
                !_vm.showCarCats
                  ? [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "44",
                            height: "16"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              d:
                                "M38.616 4.772h2.294c.11 0 .22-.025.32-.071l1-.464.215-.1v5.575l-.088.041-3.723 1.725-.15.069-.057-.154-.114-.309a3.67 3.67 0 0 0-3.428-2.39A3.64 3.64 0 0 0 31.4 11.25l-.067.212-.033.106h-.111l-19.443.013h-.111l-.034-.106-.066-.214a3.64 3.64 0 0 0-3.49-2.568 3.638 3.638 0 0 0-3.49 2.573l-.065.214-.034.106h-.111l-1.587.001h-.12l-.028-.117-.964-4.113-.027-.118.108-.053.217-.107C3.35 6.39 5.564 5.9 8.527 5.621a54.99 54.99 0 0 1 4.966-.23c.388 0 .75.004 1.079.013h10.476a.76.76 0 0 0 0-1.518h-7.611l.515-.284 1.696-.938a7.375 7.375 0 0 1 1.905-.74c.96-.22 2.047-.33 3.228-.33 6.264 0 13.463 3.085 13.535 3.116.095.04.196.062.3.062zm-3.73 9.71a2.138 2.138 0 0 1-2.136-2.136c0-1.177.958-2.135 2.135-2.135 1.178 0 2.135.958 2.135 2.135a2.138 2.138 0 0 1-2.135 2.136zm-26.84 0a2.138 2.138 0 0 1-2.136-2.136c0-1.177.958-2.135 2.136-2.135 1.177 0 2.135.958 2.135 2.135a2.138 2.138 0 0 1-2.135 2.136zM24.786.076c-1.3 0-2.503.124-3.572.368a8.877 8.877 0 0 0-2.298.89 242.796 242.796 0 0 0-4.405 2.483l-.073.043-.037.02h-.042l-.084-.001c-.172-.003-.45-.007-.804-.007-2.937 0-10.1.234-13.152 2.407a.758.758 0 0 0-.299.793l1.276 5.448c.081.345.385.586.74.586l2.308-.002h.112l.033.107.066.214A3.638 3.638 0 0 0 8.045 16a3.683 3.683 0 0 0 3.493-2.58l.066-.214.033-.107h.112l19.43-.013h.112l.033.108.066.215A3.682 3.682 0 0 0 34.885 16a3.677 3.677 0 0 0 3.502-2.612l.053-.18.027-.09.092-.016.185-.033a.782.782 0 0 0 .191-.058l4.588-2.125a.761.761 0 0 0 .44-.69V4.029c0-.498-.25-.955-.67-1.222a1.446 1.446 0 0 0-1.389-.092l-1.131.526-.031.014H38.77l-.028-.012-.056-.023C37.417 2.694 30.783.076 24.787.076V0v.076z",
                              fill: "#F9BA00",
                              "fill-rule": "evenodd"
                            }
                          })
                        ]
                      )
                    ]
                  : [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "#ccd0d7",
                            "stroke-width": "2",
                            "stroke-linecap": "square",
                            "stroke-linejoin": "arcs"
                          }
                        },
                        [
                          _c("line", {
                            attrs: { x1: "18", y1: "6", x2: "6", y2: "18" }
                          }),
                          _vm._v(" "),
                          _c("line", {
                            attrs: { x1: "6", y1: "6", x2: "18", y2: "18" }
                          })
                        ]
                      )
                    ]
              ],
              2
            ),
            _vm._v(" "),
            _c("transition", [
              _vm.showCarCats
                ? _c("div", { staticClass: "steps-navigation" }, [
                    _c("div", { staticClass: "steps-navigation__container" }, [
                      _c(
                        "div",
                        {
                          staticClass: "navi-steps tri-cta row animate-tri-cta"
                        },
                        [
                          _c("div", { staticClass: "col-12 h3" }, [
                            _c("span", { staticClass: "menu-two__headline" }, [
                              _vm._v(":")
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "visible-xs" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "TuningFanatics::Template.carPartsTitle"
                                  )
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12" }, [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-12 step active" }, [
                                _c("div", { staticClass: "select-wrap" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.activeCarL1Cat,
                                          expression: "activeCarL1Cat"
                                        }
                                      ],
                                      attrs: { disabled: _vm.isLoading },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.activeCarL1Cat = $event.target
                                            .multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { attrs: { selected: "", value: "" } },
                                        [_vm._v("Marke")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 693 } },
                                        [_vm._v("VW")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 662 } },
                                        [_vm._v("Audi")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 663 } },
                                        [_vm._v("BMW")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 678 } },
                                        [_vm._v("Mercedes")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 682 } },
                                        [_vm._v("Opel")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 669 } },
                                        [_vm._v("Ford")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 687 } },
                                        [_vm._v("Seat")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 688 } },
                                        [_vm._v("Skoda")]
                                      ),
                                      _vm._v(" "),
                                      _c("option", {
                                        attrs: { value: "", disabled: "" }
                                      }),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.carCategories.children,
                                        function(cat) {
                                          return _c(
                                            "option",
                                            { domProps: { value: cat.id } },
                                            [
                                              _vm._v(
                                                _vm._s(cat.details[0].name)
                                              )
                                            ]
                                          )
                                        }
                                      )
                                    ],
                                    2
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 step" }, [
                                _c("div", { staticClass: "select-wrap" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.activeCarL2Cat,
                                          expression: "activeCarL2Cat"
                                        }
                                      ],
                                      attrs: {
                                        disabled:
                                          _vm.isLoading || !_vm.activeCarL1Cat
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.activeCarL2Cat = $event.target
                                            .multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { attrs: { selected: "", value: "" } },
                                        [_vm._v("Modell")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.carL1Category.children,
                                        function(cat2) {
                                          return _c(
                                            "option",
                                            { domProps: { value: cat2.id } },
                                            [
                                              _vm._v(
                                                _vm._s(cat2.details[0].name)
                                              )
                                            ]
                                          )
                                        }
                                      )
                                    ],
                                    2
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 step" }, [
                                _c("div", { staticClass: "select-wrap" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.activeCarL3Cat,
                                          expression: "activeCarL3Cat"
                                        }
                                      ],
                                      attrs: {
                                        disabled:
                                          _vm.isLoading || !_vm.activeCarL2Cat
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.activeCarL3Cat = $event.target
                                            .multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { attrs: { selected: "", value: "" } },
                                        [_vm._v("Typ")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.carL2Category.children,
                                        function(cat3) {
                                          return _c(
                                            "option",
                                            { domProps: { value: cat3.id } },
                                            [
                                              _vm._v(
                                                _vm._s(cat3.details[0].name)
                                              )
                                            ]
                                          )
                                        }
                                      )
                                    ],
                                    2
                                  )
                                ])
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 step last" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "menu-two__btn menu-two__btn--mobile",
                                attrs: {
                                  disabled: _vm.isLoading || !_vm.activeCarL1Cat
                                },
                                on: { click: _vm.redirectToCat }
                              },
                              [_vm._v("Finden")]
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isLoading,
                            expression: "isLoading"
                          }
                        ],
                        staticClass: "steps-navigation__is-loading"
                      },
                      [_c("i", { staticClass: "fa fa-refresh fa-spin" })]
                    )
                  ])
                : _vm._e()
            ])
          ],
          1
        )
      : _c("div", { staticClass: "navigation__wrapper" }, [
          _c(
            "div",
            { staticClass: "navigation" },
            [
              _c("div", { staticClass: "primary-navigation" }, [
                _c("div", { staticClass: "primary-navigation__container" }, [
                  _c("div", { staticClass: "primary-navigation__row" }, [
                    _c("div", { staticClass: "primary-navigation__item" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate("Ceres::Template.itemCategories")
                        ) + " "
                      ),
                      _c("i", {
                        staticClass: "fa fa-angle-down",
                        class: { "cat-open": _vm.showTypeCats },
                        attrs: { "aria-hidden": "true" }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "primary-navigation__item primary-navigation__item--teile",
                        on: {
                          click: function($event) {
                            _vm.showCarCats = !_vm.showCarCats
                            _vm.showTypeCats = false
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "TuningFanatics::Template.carPartsTitle"
                            )
                          ) + " "
                        ),
                        _c("i", {
                          staticClass: "fa fa-angle-down",
                          class: { "cat-open": _vm.showCarCats },
                          attrs: { "aria-hidden": "true" }
                        })
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.showTypeCats
                ? _c("div", { staticClass: "megamenu" }, [
                    _vm.typeCategories.children.length
                      ? _c("div", { staticClass: "megamenu__left" }, [
                          _c(
                            "ul",
                            { staticClass: "megamenu__nav" },
                            _vm._l(_vm.typeCategories.children, function(cat) {
                              return _c(
                                "li",
                                {
                                  staticClass: "megamenu__nav-item",
                                  on: {
                                    mouseover: function($event) {
                                      return _vm.switchActiveTypeCat(cat)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "megamenu__nav-link",
                                      attrs: {
                                        href:
                                          "/" +
                                          _vm.getCategoryUrl(
                                            _vm.typeCategories.details[0]
                                              .nameUrl +
                                              "/" +
                                              cat.details[0].nameUrl
                                          ),
                                        title: cat.details[0].name
                                      }
                                    },
                                    [_vm._v(_vm._s(cat.details[0].name))]
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.typeCategoriesActiveChild.details
                      ? _c("div", { staticClass: "megamenu__right" }, [
                          _c("div", { staticClass: "megamenu__sec-headline" }, [
                            _vm._v(
                              _vm._s(
                                _vm.typeCategoriesActiveChild.details[0].name
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "megamenu__sec-nav" },
                            _vm._l(
                              _vm.typeCategoriesActiveChild.children,
                              function(catChild) {
                                return _c(
                                  "li",
                                  { staticClass: "megamenu__sec-nav-item" },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "megamenu__sec-nav-link",
                                        attrs: {
                                          href:
                                            "/" +
                                            _vm.getCategoryUrl(
                                              _vm.typeCategories.details[0]
                                                .nameUrl +
                                                "/" +
                                                _vm.typeCategoriesActiveChild
                                                  .details[0].nameUrl +
                                                "/" +
                                                catChild.details[0].nameUrl
                                            ),
                                          title: catChild.details[0].name
                                        }
                                      },
                                      [_vm._v(_vm._s(catChild.details[0].name))]
                                    )
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "megamenu__newsletter-banner",
                              attrs: {
                                href:
                                  "https://www.tuning-fanatics.de/geschenkgutscheine/"
                              }
                            },
                            [
                              _c("lazy-img", {
                                attrs: {
                                  "picture-class": "megamenu__newsletter",
                                  "image-url":
                                    "https://www.tuning-fanatics.de/layout/od_tuning_fanatics_v2/images/gutschein-banner.jpg",
                                  "fallback-url":
                                    "https://www.tuning-fanatics.de/layout/od_tuning_fanatics_v2/images/gutschein-banner.jpg",
                                  alt: "Gutschein Banner"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("transition", [
                _vm.showCarCats
                  ? _c("div", { staticClass: "steps-navigation" }, [
                      _c(
                        "div",
                        { staticClass: "steps-navigation__container" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "navi-steps tri-cta row animate-tri-cta"
                            },
                            [
                              _c("div", { staticClass: "col-sm-2 h3" }, [
                                _c(
                                  "span",
                                  { staticClass: "menu-two__headline" },
                                  [_vm._v(":")]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "visible-xs" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "TuningFanatics::Template.myCar"
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-sm-8" }, [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-xs-12 col-sm-4 step active"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _vm.carCategories.children
                                            ? _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.activeCarL1Cat,
                                                      expression:
                                                        "activeCarL1Cat"
                                                    }
                                                  ],
                                                  on: {
                                                    change: function($event) {
                                                      var $$selectedVal = Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function(o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function(o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                      _vm.activeCarL1Cat = $event
                                                        .target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "option",
                                                    {
                                                      attrs: {
                                                        selected: "",
                                                        disabled: "",
                                                        value: ""
                                                      }
                                                    },
                                                    [_vm._v("Marke")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "option",
                                                    {
                                                      domProps: { value: 693 }
                                                    },
                                                    [_vm._v("VW")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "option",
                                                    {
                                                      domProps: { value: 662 }
                                                    },
                                                    [_vm._v("Audi")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "option",
                                                    {
                                                      domProps: { value: 663 }
                                                    },
                                                    [_vm._v("BMW")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "option",
                                                    {
                                                      domProps: { value: 678 }
                                                    },
                                                    [_vm._v("Mercedes")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "option",
                                                    {
                                                      domProps: { value: 682 }
                                                    },
                                                    [_vm._v("Opel")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "option",
                                                    {
                                                      domProps: { value: 669 }
                                                    },
                                                    [_vm._v("Ford")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "option",
                                                    {
                                                      domProps: { value: 687 }
                                                    },
                                                    [_vm._v("Seat")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "option",
                                                    {
                                                      domProps: { value: 688 }
                                                    },
                                                    [_vm._v("Skoda")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("option", {
                                                    attrs: {
                                                      value: "",
                                                      disabled: ""
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    _vm.carCategories.children,
                                                    function(cat) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          domProps: {
                                                            value: cat.id
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              cat.details[0]
                                                                .name
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  )
                                                ],
                                                2
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-12 col-sm-4 step" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.activeCarL2Cat,
                                                  expression: "activeCarL2Cat"
                                                }
                                              ],
                                              attrs: {
                                                disabled:
                                                  _vm.isLoading ||
                                                  !_vm.activeCarL1Cat
                                              },
                                              on: {
                                                change: function($event) {
                                                  var $$selectedVal = Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function(o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function(o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                  _vm.activeCarL2Cat = $event
                                                    .target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    selected: "",
                                                    value: ""
                                                  }
                                                },
                                                [_vm._v("Modell")]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.carL1Category.children,
                                                function(cat2) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      domProps: {
                                                        value: cat2.id
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          cat2.details[0].name
                                                        )
                                                      )
                                                    ]
                                                  )
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-12 col-sm-4 step" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.activeCarL3Cat,
                                                  expression: "activeCarL3Cat"
                                                }
                                              ],
                                              attrs: {
                                                disabled:
                                                  _vm.isLoading ||
                                                  !_vm.activeCarL2Cat ||
                                                  !_vm.carL2Category.children ||
                                                  _vm.carL2Category.children
                                                    .length < 1
                                              },
                                              on: {
                                                change: function($event) {
                                                  var $$selectedVal = Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function(o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function(o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                  _vm.activeCarL3Cat = $event
                                                    .target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    selected: "",
                                                    value: ""
                                                  }
                                                },
                                                [_vm._v("Typ")]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.carL2Category.children,
                                                function(cat3) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      domProps: {
                                                        value: cat3.id
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          cat3.details[0].name
                                                        )
                                                      )
                                                    ]
                                                  )
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-xs-12 col-sm-2 step last" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "menu-two__btn",
                                      attrs: {
                                        disabled:
                                          _vm.isLoading || !_vm.activeCarL1Cat
                                      },
                                      on: { click: _vm.redirectToCat }
                                    },
                                    [_vm._v("Finden")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isLoading,
                                      expression: "isLoading"
                                    }
                                  ],
                                  staticClass: "steps-navigation__is-loading"
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-refresh fa-spin"
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ])
            ],
            1
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }